import { services } from '../services';
var action = "property-cancelation";
/* eslint-disable no-console */
export const propertycancelationService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getPropertyCancellationContract,
    approve,
    denie,
    getStatusList
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getPropertyCancellationContract(id) {
    return services.restApi(`cancelation/contract/${id}`, 'GET');
}

function approve(id) {
    return services.restApi(`properties/cancel/approve/${id}`, 'POST');
}

function denie(id) {
    return services.restApi(`properties/cancel/denied/${id}`, 'POST');
}

function getStatusList() {
    return services.restApi(`propertycancelationstatus/`, 'GET');
}
